module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_footer_image_03-41ae4e357b2df06976e0c187123aab1e.jpg";